import {useParams} from "react-router-dom";
import {getItem} from "tools/localStorage";

export default () => {
  const params = useParams();
  const localStorageExhibitorId = getItem<string | undefined>(
    "exhibitorPairId"
  );
  return ((params?.exhibitorPairId as string) || localStorageExhibitorId)!;
};
